import { useState, useEffect } from 'react';
import { pedidosService } from '../../services';
import { formatCurrency, formatDateTime } from '../../utils/format';
import './Pedidos.css';

const statusLabels = {
  aberto: 'Aberto',
  preparando: 'Preparando',
  pronto: 'Pronto',
  a_caminho: 'A Caminho',
  entregue: 'Entregue',
  pago: 'Pago',
  cancelado: 'Cancelado',
};

const statusColors = {
  aberto: 'badge-info',
  preparando: 'badge-warning',
  pronto: 'badge-success',
  a_caminho: 'badge-info',
  entregue: 'badge-success',
  pago: 'badge-success',
  cancelado: 'badge-danger',
};

export default function Pedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [filtroTipo, setFiltroTipo] = useState('');
  const [loading, setLoading] = useState(true);

  const carregar = () => {
    setLoading(true);
    const params = {};
    if (filtroStatus) params.status = filtroStatus;
    if (filtroTipo) params.tipo = filtroTipo;
    pedidosService.listar(params)
      .then(res => setPedidos(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { carregar(); }, [filtroStatus, filtroTipo]); // eslint-disable-line

  const handleStatus = async (id, novoStatus) => {
    try {
      await pedidosService.atualizarStatus(id, novoStatus);
      carregar();
    } catch {}
  };

  return (
    <div className="pedidos-page">
      <div className="page-header">
        <h1>🧾 Pedidos</h1>
        <div className="filtros">
          <select value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)}>
            <option value="">Todos os tipos</option>
            <option value="mesa">Mesa</option>
            <option value="delivery">Delivery</option>
            <option value="balcao">Balcão</option>
          </select>
          <select value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)}>
            <option value="">Todos os status</option>
            {Object.entries(statusLabels).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>
      </div>

      {loading ? (
        <div className="loading"><div className="spinner"></div>Carregando...</div>
      ) : (
        <div className="table-container card">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Tipo</th>
                <th>Mesa/Cliente</th>
                <th>Total</th>
                <th>Status</th>
                <th>Data</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {pedidos.map(p => (
                <tr key={p.id}>
                  <td><strong>{p.numero}</strong></td>
                  <td><span className="tipo-tag">{p.tipo}</span></td>
                  <td>{p.mesa_numero ? `Mesa ${p.mesa_numero}` : p.cliente_nome || '-'}</td>
                  <td><strong>{formatCurrency(p.total)}</strong></td>
                  <td><span className={`badge ${statusColors[p.status]}`}>{statusLabels[p.status]}</span></td>
                  <td>{formatDateTime(p.created_at)}</td>
                  <td className="acoes">
                    {p.status === 'aberto' && (
                      <button className="btn btn-sm btn-warning" onClick={() => handleStatus(p.id, 'preparando')}>Preparar</button>
                    )}
                    {p.status === 'preparando' && (
                      <button className="btn btn-sm btn-success" onClick={() => handleStatus(p.id, 'pronto')}>Pronto</button>
                    )}
                    {p.status === 'pronto' && (
                      <button className="btn btn-sm btn-primary" onClick={() => handleStatus(p.id, 'entregue')}>Entregar</button>
                    )}
                    {!['pago', 'cancelado'].includes(p.status) && (
                      <button className="btn btn-sm btn-danger" onClick={() => handleStatus(p.id, 'cancelado')}>Cancelar</button>
                    )}
                  </td>
                </tr>
              ))}
              {pedidos.length === 0 && (
                <tr><td colSpan="7" className="no-data">Nenhum pedido encontrado</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
